/* ============================================================================
   LOVELOOP — "STOP AT" campaign popup
   Loaded by sections/loveloop-popup.liquid, which sets window.LOVELOOP_POPUP
   from the theme-editor settings before this file runs.

   Integration points are numbered in comments throughout. The ones that still
   need server work are 2 (attempt validation) and 3/4 (unique reward codes).
   ========================================================================== */

(function () {
  'use strict';

  /* ==========================================================================
     1. CONFIG
     One object. Everything the theme editor can change is merged over these
     defaults by the section, so this file is not where you run a campaign from.
     ========================================================================== */
  var CONFIG = {
    BRAND: 'LOVELOOP',

    /* The clock runs DOWN from RUN_MS and the visitor must freeze it on
       TARGET_TIME exactly. No tolerance window. Format is SS.hh.
       Reaching 00.00 is a loss in itself — the countdown time-boxes the run. */
    RUN_MS: 10000,
    TARGET_TIME: '07.00',

    /* INTEGRATION POINT 8 — popup timing. */
    OPEN_DELAY_MS: 5000,
    COOLDOWN_HOURS: 48,

    /* How many times the popup may open itself for one visitor who never plays.
       Without a cap, a regular customer who simply is not interested keeps being
       asked every cooldown, forever. 0 means unlimited. */
    MAX_AUTO_SHOWS: 3,

    /* INTEGRATION POINT 4 — the winner's reward code.

       READ THIS BEFORE CHANGING IT. This value ships inside the page, so anyone
       who opens the page source can read it without ever playing. That is
       tolerable ONLY because it is a deliberately shared campaign code whose
       real protection is the cart minimum and the one-use-per-customer limit —
       not secrecy.

       If you ever move to unique per-winner codes, do NOT put them here. Have
       unlockReward() return { code: '...' } from your server; the reveal below
       already prefers a server code over this one and falls back to it. */
    REWARD_CODE: 'BESTBOXERSINTHEGAME',
    REWARD_TERMS: 'Free 2-pack on orders over 50€. One per customer.',

    /* INTEGRATION POINT 7 — WhatsApp channel. */
    WHATSAPP_CHANNEL_URL: '',

    PRIVACY_POLICY_URL: '/policies/privacy-policy',

    /* INTEGRATION POINT 6 — artwork. All three are supplied by the section from
       theme assets or the image pickers; empty here on purpose. */
    CAMPAIGN_IMAGE_URL: '',
    LOGO_URL: '',
    PRIZE_IMAGE_URL: '',
    BACKGROUND_BLUR_PX: 22,

    STORAGE_KEY: 'loveloop_stop_v1',
    SOUND_KEY: 'loveloop_stop_v1_sound',
    SOUND_ON_BY_DEFAULT: true,

    /* See INTEGRATION POINT 10. Off until you actually wire a destination. */
    ANALYTICS_ENABLED: false,

    /* See the note in Store.write. */
    REQUIRE_PREFERENCES_CONSENT: false
  };

  /* Settings from the theme editor win over the defaults above. Split out so it
     can run again when the editor re-renders the section with new values. */
  function applyOverrides() {
    if (!window.LOVELOOP_POPUP) return;
    for (var k in window.LOVELOOP_POPUP) {
      if (Object.prototype.hasOwnProperty.call(window.LOVELOOP_POPUP, k)) {
        CONFIG[k] = window.LOVELOOP_POPUP[k];
      }
    }
  }
  applyOverrides();

  var COOLDOWN_MS = CONFIG.COOLDOWN_HOURS * 60 * 60 * 1000;


  /* ==========================================================================
     2. THE SERVER BOUNDARY

     Each function is async and returns a plain result object, so swapping a stub
     for a real fetch() is a body swap, not a rewrite. The recommended transport
     for the remaining two is a Shopify App Proxy (/apps/loveloop/...), which is
     same-origin and authenticated without any Admin credential in the browser.
     ========================================================================== */

  /* --- INTEGRATION POINT 1 — subscriber registration — LIVE ------------------
     Posts to the same endpoint the theme's own newsletter form uses: Shopify's
     customer form renders action="/contact" with form_type=customer. Shopify
     creates the customer (or matches an existing one by email — it will not
     duplicate) and sets email marketing consent. No app, no server, no key.

     With double opt-in on in Settings > Notifications, Shopify sends the
     confirmation mail and the address only counts as subscribed once clicked.

     Same-origin only, so this fails from a local file — expected. The clock is
     never made to wait on it, so a failed subscribe cannot cost someone a run.
  --------------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------------
     SUBSCRIBING THE ADDRESS — read this before changing it.

     This shop has Shopify's spam protection switched on, so a POST to /contact
     carrying form_type=customer is only accepted when it also carries an
     hCaptcha token. Shopify's own script attaches that token, and only to real
     forms rendered in the page. A fetch() can never carry one. Neither can a
     form built in JavaScript and sent with form.submit(), because that fires no
     submit event for the script to intercept. Both are refused with a 403
     challenge page and the address is gone, silently.

     So the address goes through the Liquid {% form 'customer' %} the section
     renders (id="llSubscribe"), which Shopify wires up at page load, posting
     into a hidden iframe so the visitor stays on the page mid-run.
     https://shopify.dev/docs/storefronts/themes/trust-security/captcha
  --------------------------------------------------------------------------- */
  var SUB_QUEUE_KEY = 'loveloop_sub_queue';
  var SUB_MAX_TRIES = 3;
  var pendingEmail = null;
  var sinkWatched = false;

  function readQueue() {
    try {
      var raw = window.localStorage.getItem(SUB_QUEUE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!list || !list.length) return [];
      /* Entries written by an earlier version were bare strings. */
      return list.map(function (item) {
        return typeof item === 'string' ? { e: item, n: 0 } : item;
      }).filter(function (item) { return item && item.e; });
    } catch (e) { return []; }
  }

  function writeQueue(list) {
    try { window.localStorage.setItem(SUB_QUEUE_KEY, JSON.stringify(list.slice(-5))); } catch (e) {}
  }

  function queueEmail(email) {
    var q = readQueue();
    for (var i = 0; i < q.length; i++) { if (q[i].e === email) return; }
    q.push({ e: email, n: 0 });
    writeQueue(q);
  }

  function unqueueEmail(email) {
    writeQueue(readQueue().filter(function (item) { return item.e !== email; }));
  }

  function submitSubscribe(email) {
    var form = document.getElementById('llSubscribe');
    var field = document.getElementById('llSubscribeEmail');
    if (!form || !field) return false;
    try {
      field.value = email;
      pendingEmail = email;
      form.submit();
      return true;
    } catch (err) {
      console.warn('[LOVELOOP] could not submit the subscribe form', err);
      return false;
    }
  }

  /* The iframe is same-origin, so where it lands tells us whether Shopify took
     the address. Its own page means accepted; /challenge means the visitor was
     sent to an interactive spam check they cannot see, so the address stays
     queued and is tried again on a later page view. */
  function watchSubscribeResult() {
    if (sinkWatched) return;
    var sink = document.getElementById('llSink');
    if (!sink) return;
    sinkWatched = true;
    sink.addEventListener('load', function () {
      if (!pendingEmail) return;
      var path = '';
      try { path = sink.contentWindow.location.pathname; } catch (e) { return; }
      if (!path || path.indexOf('blank') !== -1) return;
      if (path.indexOf('/challenge') === 0) {
        console.warn('[LOVELOOP] subscribe was sent to the spam check — kept for a retry');
        pendingEmail = null;
        return;
      }
      unqueueEmail(pendingEmail);
      pendingEmail = null;
    });
  }

  function registerEmail(email) {
    queueEmail(email);
    if (submitSubscribe(email)) return;

    /* No Liquid form on the page — an older layout, or the section was edited.
       A direct post is refused wherever spam protection is on, but it beats
       dropping the address on the floor. */
    console.warn('[LOVELOOP] subscribe form missing, falling back to a direct post');
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' + encodeURIComponent(email)
    }).then(function (res) {
      if (res.ok) unqueueEmail(email);
    })['catch'](function () {});
  }

  /* Anything Shopify never confirmed is tried again on a later page view, a few
     times over, then let go so it cannot retry forever. */
  function flushSubscribeQueue() {
    var q = readQueue();
    if (!q.length) return;
    var head = q[0];
    head.n = (head.n || 0) + 1;
    if (head.n > SUB_MAX_TRIES) { q.shift(); writeQueue(q); return; }
    writeQueue(q);
    submitSubscribe(head.e);
  }

  /* ?llreset — play again from this browser without clearing site data. For
     testing a campaign that is already live; no ordinary visitor has it in a
     URL, and it changes nothing for anyone else. */
  function resetRequested() {
    return window.location.search.indexOf('llreset') !== -1;
  }

  function forceFreshRun() {
    Store.clear();
    try { window.localStorage.removeItem(SUB_QUEUE_KEY); } catch (e) {}
    CONFIG.OPEN_DELAY_MS = 0;
    CONFIG.COOLDOWN_HOURS = 0;
    CONFIG.MAX_AUTO_SHOWS = 0;
  }

  /* --- INTEGRATION POINT 2 — server-side attempt validation — STILL A STUB ---
     The localStorage/cookie lock below is a UX guard, not security. Anyone can
     clear site data and play again. Before this becomes a real giveaway:

       POST /apps/loveloop/attempt  { email }
       -> { allowed: true }  |  { allowed: false, reason: 'already_played' }

     Key the record on the *email*, not the browser, and burn the attempt the
     moment START is pressed — not at STOP — so a closed tab still spends it.
  --------------------------------------------------------------------------- */
  function validateAttemptServerSide(email) {
    return simulate({ allowed: true }, 0);
  }

  /* --- INTEGRATION POINT 3 + 4 — eligibility and unique codes — STILL A STUB -
     NEVER generate a discount code in client JavaScript. Anything the browser
     can compute, a visitor can read. When you want per-winner codes this must
     become a thin call to a server that:

       1. re-checks eligibility for this email
       2. mints a single-use code server-side
          discountCodeBasicCreate -> usageLimit: 1, appliesOncePerCustomer: true
       3. returns { code: '...' }, which the reveal below prefers over the
          shared campaign code.
  --------------------------------------------------------------------------- */
  function unlockReward(email, finalTime) {
    return simulate({ ok: true, delivery: 'shared_code' }, 0);
  }

  /* --- INTEGRATION POINT 10 — analytics funnel -------------------------------
     Inert by design: it sends nothing today, so no event leaves the page and
     there is nothing extra to consent to. Turn ANALYTICS_ENABLED on in the
     section and fill in the body when you want the funnel
     (shown -> played -> won/lost -> code copied).

     The consent check below stays, or you have traded a reporting gap for a
     tracking problem.
  --------------------------------------------------------------------------- */
  function track(event, data) {
    if (!CONFIG.ANALYTICS_ENABLED) return;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()) return;

      // GA4 via Google Tag Manager:
      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push(Object.assign({ event: 'loveloop_' + event }, data || {}));

      // Meta pixel:
      // if (window.fbq) window.fbq('trackCustom', 'Loveloop' + event, data || {});
    } catch (e) {}
  }

  function simulate(value, ms) {
    return new Promise(function (resolve) { setTimeout(function () { resolve(value); }, ms); });
  }


  /* ==========================================================================
     3. STORAGE — three separate states, deliberately

        lastShownAt  -> the popup cooldown.            A visitor may close it.
        autoShows    -> how many times it opened itself. Capped, so a visitor who
                        is not interested is eventually left alone.
        attempted    -> the attempt is spent, forever.  A visitor may not replay.

     Kept apart so "closed without playing" and "played" never bleed into each
     other. Written to localStorage with a cookie mirror, because Safari clears
     localStorage on some ITP paths but keeps the cookie.
     ========================================================================== */
  var Store = {
    read: function () {
      var raw = null;
      try { raw = window.localStorage.getItem(CONFIG.STORAGE_KEY); } catch (e) {}
      if (!raw) raw = readCookie(CONFIG.STORAGE_KEY);
      if (!raw) return {};
      try { return JSON.parse(decodeURIComponent(raw)) || {}; } catch (e) { return {}; }
    },
    write: function (patch) {
      // Whether the attempt record itself needs consent is a judgement call: it
      // exists purely to stop pestering the visitor, which is a decent necessity
      // argument, but it is not strictly essential either. Flip
      // REQUIRE_PREFERENCES_CONSENT for the stricter reading — knowing that
      // visitors who decline will then be able to replay the game.
      if (CONFIG.REQUIRE_PREFERENCES_CONSENT) {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.preferencesProcessingAllowed === 'function' && !cp.preferencesProcessingAllowed()) {
          return Store.read();
        }
      }
      var next = Store.read();
      for (var k in patch) {
        if (Object.prototype.hasOwnProperty.call(patch, k)) next[k] = patch[k];
      }
      var raw = encodeURIComponent(JSON.stringify(next));
      try { window.localStorage.setItem(CONFIG.STORAGE_KEY, raw); } catch (e) {}
      writeCookie(CONFIG.STORAGE_KEY, raw, 400);
      return next;
    },
    clear: function () {
      try { window.localStorage.removeItem(CONFIG.STORAGE_KEY); } catch (e) {}
      writeCookie(CONFIG.STORAGE_KEY, '', -1);
    }
  };

  function readCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    return parts.length === 2 ? parts.pop().split(';').shift() : null;
  }
  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function saveAttempt(email, finalTime, won, ranOut) {
    return Store.write({
      attempted: true,
      result: won ? 'win' : 'loss',
      ranOut: !!ranOut,
      time: finalTime,
      email: email,
      attemptedAt: Date.now()
    });
  }


  /* ==========================================================================
     4. SOUND — Web Audio only, no files, no library.
        Short, dry, electronic. Nothing here should sound like a slot machine.
     ========================================================================== */
  var Sound = (function () {
    var ctx = null;
    var muted = false;

    try {
      var saved = window.localStorage.getItem(CONFIG.SOUND_KEY);
      muted = saved === null ? !CONFIG.SOUND_ON_BY_DEFAULT : saved === 'off';
    } catch (e) { muted = !CONFIG.SOUND_ON_BY_DEFAULT; }

    function ensure() {
      if (muted) return null;
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      if (!ctx) { try { ctx = new AC(); } catch (e) { return null; } }
      // Every sound follows a real click, so this resume() always succeeds.
      if (ctx.state === 'suspended') ctx.resume();
      return ctx;
    }

    function tone(o) {
      var c = ensure();
      if (!c) return;
      var t0 = c.currentTime + (o.delay || 0);
      var dur = o.dur || 0.08;
      var osc = c.createOscillator();
      var gain = c.createGain();
      osc.type = o.type || 'triangle';
      osc.frequency.setValueAtTime(o.from, t0);
      if (o.to) osc.frequency.exponentialRampToValueAtTime(o.to, t0 + dur);
      // Exponential envelopes only — a linear cut to zero produces a click.
      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(o.gain || 0.05, t0 + 0.006);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
      osc.connect(gain);
      gain.connect(c.destination);
      osc.start(t0);
      osc.stop(t0 + dur + 0.03);
    }

    return {
      start: function () { tone({ from: 1046, dur: 0.07, type: 'triangle', gain: 0.05 }); },
      stop:  function () { tone({ from: 392,  dur: 0.055, type: 'square',  gain: 0.038 }); },
      win:   function () {
        tone({ from: 659, dur: 0.085, gain: 0.045 });
        tone({ from: 988, dur: 0.085, gain: 0.045, delay: 0.085 });
        tone({ from: 1319, dur: 0.26, gain: 0.04,  delay: 0.17 });
      },
      loss:  function () { tone({ from: 208, to: 148, dur: 0.32, type: 'triangle', gain: 0.05 }); },
      isMuted: function () { return muted; },
      setMuted: function (v) {
        muted = !!v;
        try { window.localStorage.setItem(CONFIG.SOUND_KEY, muted ? 'off' : 'on'); } catch (e) {}
      }
    };
  })();


  /* ==========================================================================
     5. THE DISPLAY — genuine seven-segment geometry, drawn as SVG.

     Each digit is seven bevelled hexagonal bars on a 100x180 grid, laid out the
     way a real LED module is: verticals at x=16/84, horizontals at y=16/90/164,
     every bar tapering to a point at the shared corner so the notches read
     correctly. Unlit segments stay visible at 5% — that dead-LED ghosting is the
     single detail that separates a real display from a "digital" font.

     Glow is one filter on the row of digits, not per polygon, so a 60fps redraw
     stays a single GPU composite.
     ========================================================================== */
  var Display = (function () {
    var NS = 'http://www.w3.org/2000/svg';
    var H = 8;      // half thickness
    var GAP = 3.5;  // shortening at each tip, which opens the classic notch
    var LX = 16, RX = 84, TY = 16, MY = 90, BY = 164;

    function hbar(y, x1, x2) {
      var a = x1 + GAP, b = x2 - GAP;
      return [[a, y], [a + H, y - H], [b - H, y - H], [b, y], [b - H, y + H], [a + H, y + H]]
        .map(function (p) { return p.join(','); }).join(' ');
    }
    function vbar(x, y1, y2) {
      var a = y1 + GAP, b = y2 - GAP;
      return [[x, a], [x + H, a + H], [x + H, b - H], [x, b], [x - H, b - H], [x - H, a + H]]
        .map(function (p) { return p.join(','); }).join(' ');
    }

    var GEOM = {
      a: hbar(TY, LX, RX), g: hbar(MY, LX, RX), d: hbar(BY, LX, RX),
      f: vbar(LX, TY, MY), b: vbar(RX, TY, MY),
      e: vbar(LX, MY, BY), c: vbar(RX, MY, BY)
    };
    var ORDER = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
    var MAP = {
      '0': 'abcdef', '1': 'bc',     '2': 'abdeg',  '3': 'abcdg', '4': 'bcfg',
      '5': 'acdfg',  '6': 'acdefg', '7': 'abc',    '8': 'abcdefg', '9': 'abcdfg'
    };

    var slots = [];

    function buildDigit() {
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('viewBox', '0 0 100 180');
      svg.setAttribute('focusable', 'false');
      var segs = {};
      ORDER.forEach(function (key) {
        var poly = document.createElementNS(NS, 'polygon');
        poly.setAttribute('points', GEOM[key]);
        poly.setAttribute('class', 'll-seg');
        svg.appendChild(poly);
        segs[key] = poly;
      });
      return { svg: svg, segs: segs, value: null };
    }

    function buildPoint() {
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('viewBox', '0 0 32 180');
      svg.setAttribute('focusable', 'false');
      var r = document.createElementNS(NS, 'rect');
      r.setAttribute('x', '7'); r.setAttribute('y', '153');
      r.setAttribute('width', '18'); r.setAttribute('height', '18');
      r.setAttribute('rx', '3');
      r.setAttribute('class', 'll-point');
      svg.appendChild(r);
      return svg;
    }

    return {
      mount: function (host) {
        host.textContent = '';
        slots.length = 0;          // mount() can run again in the theme editor
        [0, 1].forEach(function () {
          var d = buildDigit();
          var wrap = document.createElement('div');
          wrap.className = 'll-digit';
          wrap.appendChild(d.svg);
          host.appendChild(wrap);
          slots.push(d);
        });
        var dot = document.createElement('div');
        dot.className = 'll-dot';
        dot.appendChild(buildPoint());
        host.appendChild(dot);
        [2, 3].forEach(function () {
          var d = buildDigit();
          var wrap = document.createElement('div');
          wrap.className = 'll-digit';
          wrap.appendChild(d.svg);
          host.appendChild(wrap);
          slots.push(d);
        });
      },

      /* Accepts 'SS.hh'. Only segments whose state actually changed are touched,
         so a frame costs a handful of classList toggles at most. */
      set: function (str) {
        var chars = str.replace('.', '').split('');
        for (var i = 0; i < 4; i++) {
          var slot = slots[i];
          var ch = chars[i];
          if (slot.value === ch) continue;
          var lit = MAP[ch] || '';
          for (var j = 0; j < ORDER.length; j++) {
            var key = ORDER[j];
            slot.segs[key].classList.toggle('is-lit', lit.indexOf(key) !== -1);
          }
          slot.value = ch;
        }
      }
    };
  })();


  /* ==========================================================================
     6. TIMER

     performance.now() is the source of truth; requestAnimationFrame only decides
     when to repaint. The displayed value is therefore never accumulated frame by
     frame and never drifts.

     Truncating the REMAINING time is what a countdown display does: it shows the
     hundredths still left, so 7000ms and 7009ms of remaining both read 07.00.
     The win window is therefore 10ms of real time — genuinely narrow, with no
     hidden padding on either side.
     ========================================================================== */
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function formatRemaining(elapsedMs) {
    var remaining = CONFIG.RUN_MS - elapsedMs;
    if (remaining < 0) remaining = 0;
    var hundredths = Math.floor(remaining / 10);
    if (hundredths > 9999) hundredths = 9999;
    return pad2(Math.floor(hundredths / 100)) + '.' + pad2(hundredths % 100);
  }


  /* ==========================================================================
     7. UI + STATE MACHINE

     States: idle -> running -> win | loss
     The LED display is pinned by the content grid and never moves; a state
     change swaps only the copy above it and the controls below it.
     ========================================================================== */
  var el = {};
  var Game = { state: 'idle', running: false, locked: false, startedAt: 0, raf: 0, email: '', code: '' };
  var lastFocused = null;
  var openTimer = 0;

  function $(id) { return document.getElementById(id); }

  function cacheDom() {
    el.root      = $('llRoot');
    el.modal     = $('llModal');
    el.bg        = $('llBg');
    el.head      = $('llHead');
    el.foot      = $('llFoot');
    el.digits    = $('llDigits');
    el.srTime    = $('llSrTime');
    el.announce  = $('llAnnounce');
    el.form      = $('llForm');
    el.email     = $('llEmail');
    el.error     = $('llError');
    el.start     = $('llStart');
    el.consent   = $('llConsent');
    el.consentLabel = el.root.querySelector('.ll-consent');
    el.privacy   = $('llPrivacy');
    el.stop      = $('llStop');
    el.code       = $('llCode');
    el.codeValue  = $('llCodeValue');
    el.codeAction = $('llCodeAction');
    el.rewardTerms = $('llRewardTerms');
    el.close     = $('llClose');
    el.sound     = $('llSound');
    el.lossTitle = $('llLossTitle');
    el.lossSub   = $('llLossSub');
    el.wa        = document.querySelectorAll('[data-ll-wa]');
  }

  function setState(next) {
    Game.state = next;
    [el.head, el.foot].forEach(function (zone) {
      var panels = zone.querySelectorAll('.ll-panel');
      for (var i = 0; i < panels.length; i++) {
        panels[i].classList.toggle('is-active', panels[i].getAttribute('data-state') === next);
      }
    });
    el.root.classList.toggle('is-running', next === 'running');
    el.root.classList.toggle('is-win', next === 'win');

    // Keep the dialog's accessible name in step with the visible headline.
    var title = el.head.querySelector('.ll-panel.is-active .ll-title');
    if (title) {
      el.modal.removeAttribute('aria-labelledby');
      el.modal.setAttribute('aria-label', title.textContent.trim());
    }
  }

  function showError(message) {
    el.error.textContent = message;
    el.error.classList.add('is-shown');
    el.email.setAttribute('aria-invalid', 'true');
  }
  function clearError() {
    el.error.classList.remove('is-shown');
    el.email.setAttribute('aria-invalid', 'false');
    if (el.consentLabel) el.consentLabel.classList.remove('is-invalid');
    // Text is left in place until the transition finishes, so it doesn't jump.
    setTimeout(function () {
      if (!el.error.classList.contains('is-shown')) el.error.textContent = '';
    }, 240);
  }

  /* Intentionally permissive: catch the real mistakes (empty, no @, no dot,
     stray spaces) and let the server be the authority on the rest. */
  function validateEmail(value) {
    var v = String(value || '').trim();
    if (!v) return { ok: false, message: 'Enter an email to play' };
    if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v)) return { ok: false, message: 'That email looks off' };
    return { ok: true, value: v.toLowerCase() };
  }


  /* ---- Game -------------------------------------------------------------- */

  function handleStart(event) {
    event.preventDefault();
    if (Game.locked || Game.running) return;

    var check = validateEmail(el.email.value);
    if (!check.ok) {
      showError(check.message);
      el.email.focus();
      return;
    }
    // Consent is a hard gate, not a nicety: without it the address must not be
    // stored or sent anywhere.
    if (!el.consent.checked) {
      showError('Tick the box to play');
      el.consentLabel.classList.add('is-invalid');
      el.consent.focus();
      return;
    }
    clearError();
    Game.email = check.value;

    el.start.disabled = true;

    // INTEGRATION POINT 1 + 2 — register, then confirm the attempt is allowed.
    // Both are fire-and-continue here so the clock is never gated on the network.
    // In production, await validateAttemptServerSide() BEFORE starting, and have
    // the server burn the attempt at this moment rather than at STOP.
    registerEmail(Game.email);
    validateAttemptServerSide(Game.email);

    // Keep the proof of consent with the address. A server-side record of the
    // same three facts (address, timestamp, wording version) is what you would
    // actually produce if the consent were ever challenged.
    Store.write({
      startedAt: Date.now(),
      email: Game.email,
      consent: true,
      consentAt: new Date().toISOString()
    });

    track('game_started', { email_domain: (Game.email.split('@')[1] || '') });
    Sound.start();
    startTimer();
  }

  function startTimer() {
    setState('running');
    Game.running = true;
    Display.set(formatRemaining(0));
    el.srTime.textContent = 'Timer running';

    // Focus the STOP button so Space and Enter both work immediately.
    window.setTimeout(function () { if (el.stop) el.stop.focus(); }, 60);

    Game.startedAt = performance.now();
    Game.raf = window.requestAnimationFrame(frame);
  }

  function frame() {
    var elapsed = performance.now() - Game.startedAt;
    // Hitting zero is a loss, not a safety valve — it is the game's deadline.
    if (elapsed >= CONFIG.RUN_MS) { stopTimer(0, true); return; }
    Display.set(formatRemaining(elapsed));
    Game.raf = window.requestAnimationFrame(frame);
  }

  /* `now` is captured at the very top of the click handler, before any DOM work,
     so nothing this function does can shift the recorded time. */
  function stopTimer(now, ranOut) {
    if (!Game.running) return;
    Game.running = false;
    Game.locked = true;
    window.cancelAnimationFrame(Game.raf);

    var finalTime = ranOut ? '00.00' : formatRemaining(now - Game.startedAt);
    Display.set(finalTime);            // what is on screen IS the result
    el.srTime.textContent = finalTime.replace(/^0/, '') + ' seconds';

    // A run that expired was never stopped, so it gets no stop click.
    if (!ranOut) Sound.stop();
    el.root.classList.add('is-stopped');

    determineResult(finalTime, !!ranOut);
  }

  function determineResult(finalTime, ranOut) {
    // String equality against what is on the display. No tolerance, and an
    // expired run can never win even if it lands on 00.00.
    var won = !ranOut && finalTime === CONFIG.TARGET_TIME;

    saveAttempt(Game.email, finalTime, won, ranOut);

    // Short beat between the stop click and the verdict — it reads as a decision
    // rather than a pre-baked outcome.
    window.setTimeout(function () {
      el.root.classList.remove('is-stopped');
      if (won) { showWinState(finalTime); } else { showLossState(finalTime, ranOut); }
    }, 420);
  }

  function showWinState(finalTime) {
    setState('win');
    Sound.win();
    revealReward();
    track('game_won', { time: finalTime });
    el.announce.textContent = 'Stopped at ' + finalTime + '. You win a free pair of LOVELOOP boxers. Your code is ' + CONFIG.REWARD_CODE + '.';
    window.setTimeout(function () { if (el.code) el.code.focus(); }, 120);
  }

  function showLossState(finalTime, ranOut) {
    setState('loss');
    Sound.loss();
    // Only the headline changes between the two ways of losing; the line under it
    // is the same pivot to WhatsApp either way, so it stays in the markup.
    el.lossTitle.textContent = ranOut ? 'Too slow.' : 'Missed it.';
    track('game_lost', { time: finalTime, ran_out: !!ranOut });
    el.announce.textContent = ranOut
      ? 'The clock ran out. Not a win.'
      : 'Stopped at ' + finalTime + '. Not a win.';
  }

  /* Reveals the code the winner gets. The shared campaign code shows instantly
     so the win never waits on the network; if a server later returns a code of
     its own, that one replaces it. */
  function revealReward() {
    showCode(CONFIG.REWARD_CODE);
    el.rewardTerms.textContent = CONFIG.REWARD_TERMS;

    // INTEGRATION POINT 3 + 4 — server-side eligibility and unique code minting.
    unlockReward(Game.email, Store.read().time || CONFIG.TARGET_TIME).then(function (res) {
      if (res && res.code) { showCode(res.code); }
    })['catch'](function () { /* the shared code already on screen still works */ });
  }

  function showCode(code) {
    Game.code = code;
    el.codeValue.textContent = code;
    el.code.setAttribute('aria-label', 'Discount code ' + code + '. Activate to copy.');
  }

  function copyCode() {
    var done = function () {
      el.code.classList.add('is-copied');
      el.codeAction.textContent = 'Copied';
      el.announce.textContent = 'Code copied';
      track('code_copied', {});
      window.setTimeout(function () {
        el.code.classList.remove('is-copied');
        el.codeAction.textContent = 'Copy';
      }, 2200);
    };
    var failed = function () {
      // No clipboard permission: select the text so it can be copied by hand
      // rather than leaving the winner with a button that silently does nothing.
      el.codeValue.classList.add('is-selectable');
      el.codeAction.textContent = 'Select it';
      try {
        var range = document.createRange();
        range.selectNodeContents(el.codeValue);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } catch (e) {}
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(Game.code).then(done)['catch'](function () { legacyCopy(done, failed); });
    } else {
      legacyCopy(done, failed);
    }
  }

  /* execCommand is deprecated but it is still the only copy path on older
     mobile browsers and on pages served without a secure context. */
  function legacyCopy(done, failed) {
    try {
      var ta = document.createElement('textarea');
      ta.value = Game.code;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      if (ok) { done(); } else { failed(); }
    } catch (e) { failed(); }
  }

  /* Restores a finished attempt exactly as the visitor left it — same time on
     the display, same result panel — with no sound and no animation replay. */
  function restoreAttempt(saved) {
    Game.locked = true;
    Game.email = saved.email || '';
    Display.set(saved.time || '00.00');
    el.srTime.textContent = (saved.time || '00.00').replace(/^0/, '') + ' seconds';

    if (saved.result === 'win') {
      setState('win');
      revealReward();          // a winner who comes back still needs their code
    } else {
      setState('loss');
      el.lossTitle.textContent = saved.ranOut ? 'Too slow.' : 'Missed it.';
    }
  }


  /* ---- Popup lifecycle ---------------------------------------------------- */

  /* Shopify's native consent banner owns the screen until the visitor answers it.
     Opening on top of it is bad manners and looks broken, so the open delay only
     starts once the banner is gone. A visitor who never sees a banner — outside
     the configured regions, or one who accepted on an earlier visit — waits for
     nothing and gets the popup on the normal delay. */
  function afterConsentBanner(go) {
    var shopify = window.Shopify;
    // In the theme editor there is nothing to be polite about, and waiting would
    // make the popup look broken while settings are being adjusted.
    if (shopify && shopify.designMode) { go(); return; }
    if (!shopify || typeof shopify.loadFeatures !== 'function') { go(); return; }

    var fired = false;
    var once = function () { if (!fired) { fired = true; go(); } };

    // Covers the privacy script never calling back. Cancelled the moment we know
    // a banner is actually up, so a visitor who reads it slowly is never cut off.
    var failsafe = window.setTimeout(once, 8000);

    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      window.clearTimeout(failsafe);
      if (err || !cp) { once(); return; }

      var showing = false;
      try { showing = cp.shouldShowBanner(); } catch (e) { showing = false; }
      if (!showing) { once(); return; }

      document.addEventListener('visitorConsentCollected', function handler() {
        document.removeEventListener('visitorConsentCollected', handler);
        once();
      });
    });
  }

  /* Governs automatic appearances only. A manual open — a footer trigger, a link
     in a drop email — is the visitor asking for it, and spends nothing. */
  function checkPopupCooldown() {
    var saved = Store.read();
    if (saved.attempted) return false;                 // spent — never auto-nag again
    if (CONFIG.MAX_AUTO_SHOWS > 0 && (saved.autoShows || 0) >= CONFIG.MAX_AUTO_SHOWS) return false;
    if (saved.lastShownAt && (Date.now() - saved.lastShownAt) < COOLDOWN_MS) return false;
    return true;
  }

  function openPopup(opts) {
    opts = opts || {};
    if (!el.root.hidden) return;

    var saved = Store.read();
    if (saved.attempted && !opts.force) {
      restoreAttempt(saved);
    } else if (!opts.keepState) {
      setState('idle');
    }

    lastFocused = document.activeElement;
    el.root.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    // Force a reflow so the opening transition actually runs from its start state.
    void el.root.offsetWidth;
    el.root.classList.add('is-open');

    // Only an automatic appearance counts against the cooldown and the cap.
    if (opts.auto) {
      var prior = Store.read();
      Store.write({ lastShownAt: Date.now(), autoShows: (prior.autoShows || 0) + 1 });
    }
    track('popup_shown', { state: Game.state, auto: !!opts.auto });

    window.setTimeout(function () {
      if (Game.state === 'idle' && el.email) { el.email.focus({ preventScroll: true }); }
      else {
        var first = el.foot.querySelector('.ll-panel.is-active button, .ll-panel.is-active a');
        if (first) first.focus({ preventScroll: true });
      }
    }, 420);
  }

  function closePopup() {
    if (el.root.hidden) return;
    if (Game.running) return;   // no bailing out of a live run — one attempt is one attempt

    el.root.classList.add('is-closing');
    el.root.classList.remove('is-open');

    window.setTimeout(function () {
      el.root.hidden = true;
      el.root.classList.remove('is-closing');
      document.documentElement.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }, 420);
  }

  /* Focus stays inside the dialog while it is open. */
  function trapFocus(event) {
    if (event.key !== 'Tab' || el.root.hidden) return;
    var nodes = el.modal.querySelectorAll(
      'button:not([disabled]):not([hidden]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var visible = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].offsetParent !== null) visible.push(nodes[i]);
    }
    if (!visible.length) return;
    var first = visible[0], last = visible[visible.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }


  /* ---- WhatsApp ----------------------------------------------------------- */

  function applyWhatsAppUrl() {
    var url = CONFIG.WHATSAPP_CHANNEL_URL;
    var missing = !url || url === 'PLACEHOLDER';
    for (var i = 0; i < el.wa.length; i++) {
      el.wa[i].setAttribute('href', missing ? '#' : url);
      if (missing) {
        el.wa[i].addEventListener('click', function (e) {
          // INTEGRATION POINT 7 — set the WhatsApp link in the section settings.
          e.preventDefault();
          console.warn('[LOVELOOP] WhatsApp channel link is not set in the section settings.');
        });
      }
    }
  }


  /* ---- Wiring ------------------------------------------------------------- */

  function initPopup() {
    cacheDom();
    if (!el.root) return;

    // INTEGRATION POINT 6 — artwork, applied from the section settings.
    el.bg.style.backgroundImage = 'url("' + CONFIG.CAMPAIGN_IMAGE_URL + '")';
    el.bg.style.filter = 'blur(' + CONFIG.BACKGROUND_BLUR_PX + 'px)';

    // The dialog is still hidden here, so no image can flash in unset.
    var logos = el.root.querySelectorAll('.ll-logo');
    for (var li = 0; li < logos.length; li++) { logos[li].src = CONFIG.LOGO_URL; }
    var prizeImg = el.root.querySelector('.ll-prize-img');
    if (prizeImg) { prizeImg.src = CONFIG.PRIZE_IMAGE_URL; }
    if (el.privacy) { el.privacy.href = CONFIG.PRIVACY_POLICY_URL; }

    Display.mount(el.digits);
    Display.set(formatRemaining(0));   // the clock sits full until START
    applyWhatsAppUrl();

    el.root.classList.toggle('is-muted', Sound.isMuted());
    el.sound.setAttribute('aria-pressed', String(Sound.isMuted()));
    el.sound.setAttribute('aria-label', Sound.isMuted() ? 'Unmute sound' : 'Mute sound');

    el.form.addEventListener('submit', handleStart);
    el.email.addEventListener('input', function () {
      if (el.error.classList.contains('is-shown')) clearError();
    });
    el.consent.addEventListener('change', function () {
      if (this.checked) clearError();
    });

    // performance.now() first — before any other work in this handler.
    el.stop.addEventListener('click', function () { stopTimer(performance.now()); });

    el.code.addEventListener('click', copyCode);

    el.sound.addEventListener('click', function () {
      var next = !Sound.isMuted();
      Sound.setMuted(next);
      el.root.classList.toggle('is-muted', next);
      el.sound.setAttribute('aria-pressed', String(next));
      el.sound.setAttribute('aria-label', next ? 'Unmute sound' : 'Mute sound');
      if (!next) Sound.stop();   // a small confirmation that audio is back
    });

    var dismissers = el.root.querySelectorAll('[data-ll-dismiss]');
    for (var i = 0; i < dismissers.length; i++) {
      dismissers[i].addEventListener('click', closePopup);
    }

    document.addEventListener('keydown', function (e) {
      if (el.root.hidden) return;
      if (e.key === 'Escape') { closePopup(); return; }
      trapFocus(e);
    });

    setState('idle');

    // INTEGRATION POINT 8 — auto-open, subject to the cooldown, the appearance
    // cap, the permanent one-attempt lock, and the consent banner. All four are
    // checked here, and nowhere else.
    if (checkPopupCooldown()) {
      afterConsentBanner(function () {
        openTimer = window.setTimeout(function () { openPopup({ auto: true }); }, CONFIG.OPEN_DELAY_MS);
      });
    }
  }

  /* Exposed so the theme can drive the popup from elsewhere — a "play again"
     link in a drop email, a footer trigger, a QR code landing. */
  window.LoveloopPopup = {
    open: openPopup,
    close: closePopup,
    config: CONFIG,
    _store: Store,
    _display: Display,
    _setState: setState,
    _game: Game,
    _cancelAutoOpen: function () { window.clearTimeout(openTimer); }
  };

  /* One entry point, so the theme editor can run it again from scratch. */
  function boot() {
    applyOverrides();
    if (resetRequested()) forceFreshRun();
    watchSubscribeResult();
    flushSubscribeQueue();
    COOLDOWN_MS = CONFIG.COOLDOWN_HOURS * 60 * 60 * 1000;
    window.clearTimeout(openTimer);
    Game.state = 'idle';
    Game.running = false;
    Game.locked = false;
    Game.startedAt = 0;
    Game.raf = 0;
    Game.email = '';
    Game.code = '';
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Changing a setting in the theme editor swaps the section's DOM out, taking
     every listener this file attached with it. Without re-running, the preview
     would render but do nothing. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('#llRoot')) boot();
    });
  }
})();
